import { useEffect, FC } from 'react';
import { BasicProfile } from 'app/components/Profile';
import { useAppDispatch, useAppSelector } from 'app/store';
import { fetchProfileIdsEffect } from 'app/store/Profile/effects';
import { getCurrentProfile } from 'app/store/Profile/selectors';
import { Box, Text } from '@chakra-ui/react';
import { getCreateReleaseValidations } from 'app/store/Releases/selectors';
import { fetchCreateReleaseValidationsEffect } from 'app/store/Releases/effects';
import { AppStoreNotification } from 'app/components/AppStoreNotification';

export const ProfileMobile: FC = () => {
  const dispatch = useAppDispatch();
  const currentProfile = useAppSelector(getCurrentProfile);
  const releaseValidation = useAppSelector(getCreateReleaseValidations);

  useEffect(() => {
    dispatch(fetchProfileIdsEffect());
  }, [dispatch]);

  useEffect(() => {
    if (!releaseValidation) {
      dispatch(fetchCreateReleaseValidationsEffect());
    }
  }, [dispatch, releaseValidation]);

  return (
    <Box pt={4}>
      <Box px={4}>
        <Text fontWeight={500} fontSize="xs" color="textSubdued">
          Profile
        </Text>
        <Text
          fontWeight={500}
          fontSize="2xl"
          // IPhone 13 doesn't work without wordWrap
          overflowWrap="break-word"
          sx={{
            wordWrap: 'break-word',
          }}
        >
          {currentProfile?.displayName}
        </Text>

        <AppStoreNotification mt={4} />
      </Box>
      <BasicProfile pt={8} />
    </Box>
  );
};
